<div class="not-found">
  <div aria-hidden="true" class="code">404</div>
  <div class="content">
    <h3>This page isn't available</h3>
    <div *ngIf="notFoundUrl" class="url">{{ notFoundUrl }}</div>
    <ul class="reasons">
      <li>The link is old or was mistyped.</li>
      <li>The page was moved or removed.</li>
      <li>Your account doesn't have access to it.</li>
    </ul>
    <div class="actions">
      <button (click)="goBack()" *ngIf="canGoBack" icon="pi pi-arrow-left" label="Go back" pButton type="button"></button>
      <a *roles="['ROLE_MCKAY']" class="p-button-outlined" label="Home" pButton routerLink="/mckay/{{getUserCurrent().company.uniqid}}"></a>
      <a *roles="['ROLE_CLIENT']" class="p-button-outlined" label="Home" pButton routerLink="/client/{{getUserCurrent().company.uniqid}}"></a>
    </div>
    <p class="help">Still stuck? Contact your McKay representative and give them the address above.</p>
  </div>
</div>
